import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface Props {
  name: string;
  className?: string;
  testId?: string;
}

export const PublishQueueBadge = ({ name, className, testId }: Props) => {
  const { t } = useTranslation();
  return (
    <Badge
      variant="outline"
      data-testid={testId}
      className={cn(
        'border-muted-foreground/40 px-1 py-0 font-normal text-muted-foreground',
        className,
      )}
    >
      {t('publishQueues.calendar.badge', { name })}
    </Badge>
  );
};
